import React, { Component } from 'react';
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter, Label, Button } from 'reactstrap';
import { getContacts, postSharedRecord } from "../services";
import { toast } from 'react-toastify';

class ShareSingleRecord extends Component {

  state = {
    contactLoading: true,
    contacts: [],
    contact: null
  }

  async componentDidMount() {
    const response = await getContacts();

    const contacts = response.data.contacts.map((contact, index) => {
      return { label: contact.name, value: contact._id }
    })
    this.setState(prevState => ({
      contactLoading: false,
      contacts
    }))
  }

  handleContact = (selectedContact) => {
    this.setState(prevState => ({
      contact: selectedContact['value']
    }))
  }

  handleSubmit = async () => {

    const { contact } = this.state;

    if(contact == null) {
      toast.error("Please select a contact");
      return;
    }

    let data = {
      recordList: [this.props.recordId],
      contact,
      model: this.props.model
    }

    const response = await postSharedRecord(data);
    toast.success("Your record is successfully shared");
    this.props.toggle()
  }

  render() {
    const { contacts, contactLoading } = this.state
    return (
      <Modal isOpen={this.props.isOpen}>
        <ModalHeader toggle={this.props.toggle}>
          Share Record
        </ModalHeader>
        <ModalBody>
          <Label>Select Contact</Label>
          <Select 
            options={contacts}
            isLoading={contactLoading}
            onChange={this.handleContact}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.handleSubmit}>Share</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ShareSingleRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareSingleRecord.js